module.exports = __webpack_public_path__ + "static/media/linkedin.eeb32b23.svg";